import { Avatar, Button, Collapse, Flex, Text } from '@chakra-ui/core'
import React from 'react'
import colors from 'constants/colors'
import { CustomCheckBox } from '../GroupsTree/style'
import { Item } from './Control'
import LocaleText from 'components/LocaleText'
import { useSelector } from 'react-redux'
import { RootState } from 'constants/interfaces'

interface IItem {
  item: Item
  handleCheckIds: (id: string) => void
  checkedIds: string[]
  mode: string
  disabled?: boolean
  isExpanded?: boolean
  onToggle?: () => void
}

export const ListNode = ({
  item,
  handleCheckIds,
  checkedIds,
  mode,
  disabled = false,
  isExpanded = false,
  onToggle,
}: IItem) => {
  const theme = useSelector((state: RootState) => state?.general?.theme)

  return (
    <Flex flexDir="row" px="15px" pt="15px" mb="10px" alignItems={'center'}>
      <CustomCheckBox
        onChange={() => !disabled && handleCheckIds(item.id)}
        isChecked={checkedIds.includes(item.id)}
        mt={'0px'}
        mode={mode}
        color={theme?.elementsColor}
        hoverColor={theme?.backgroundLight}
        isDisabled={disabled}
      />
      {item?.image && <Avatar src={item?.image} mx="10px" w="40px" h="40px" />}
      <Flex flexDir="column" mx="10px" maxW="200px">
        <Text>
          <LocaleText text={item?.name} />
        </Text>
        {item?.groups && (
          <Collapse startingHeight={20} isOpen={isExpanded}>
            <Text color={colors.greyDark}>{item?.groups.join(',')}</Text>
          </Collapse>
        )}
      </Flex>
      {item?.groups && item?.groups?.join(',').length > 20 && (
        <Button
          bg={'none'}
          _hover={{ background: 'none' }}
          _active={{ background: 'none' }}
          _focus={{ boxShadow: 'none' }}
          onClick={onToggle}
          color={colors.greyDark}
        >
          <LocaleText text={isExpanded ? 'see_less_sidebar' : 'see_more_sidebar'} />
        </Button>
      )}
    </Flex>
  )
}
